import { useState, useEffect } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import ImageCard from './imageCard';
import './style.css';
import {
  DownloadImages,
  DownloadHighResImages,
  useProductImages,
} from '../../services/useProductDetail';
import { Image, ImageType } from '../../models/image';

const HighResImages = (props: any) => {
  const [selImageIds, setSelImageIds] = useState<any[]>([]);
  const [selImageNames, setSelImageNames] = useState<any[]>([]);
  const [allChecked, setAllChecked] = useState(false);
  const [images, setImages] = useState(props.productImages);
  const [isLoading, setIsLoading] = useState(false);
  const handleDownloadClick = (e: any) => {
    setIsLoading(true);
    let _selImageIds = [...selImageIds];
    let _fileName = '';
    if (_selImageIds.length == 0) {
      return;
    } else if (_selImageIds.length == 1) {
      _fileName = selImageNames[0] + '.jpg';
    } else if (_selImageIds.length > 1) {
      _fileName = props.sku + '.zip';
    }
    var params = {
      sku: props.sku,
      imageIds: _selImageIds,
      fileName: _fileName,
    };
    DownloadHighResImages(params).then(() => setIsLoading(false));
  };

  const handleSelectAllClick = (e: any) => {
    setAllChecked(e.target.checked);
    let _images = images;
    const _imageIds: string[] = [];
    _images.map((image: Image, index: number) => {
      image.IsChecked = e.target.checked;
      if (e.target.checked) {
        _imageIds.push(image.ImageId);
      }
    });
    setImages(_images);
    setSelImageIds(_imageIds);
  };

  const handleSelectImage = (e: any, imageId: string, imageName: string) => {
    let _selImageIds = [...selImageIds];
    let _selImageNames = [...selImageNames];
    let _images = [...images];
    let _allChecked = allChecked;
    if (e.target.checked) {
      _selImageIds.push(imageId);
      _selImageNames.push(imageName);
      _images.map((image: Image, index: number) => {
        if (image.ImageId == imageId) {
          image.IsChecked = true;
        }
        if (!image.IsChecked) {
          _allChecked = false;
        }
      });
    } else {
      var index = _selImageIds.indexOf(imageId);
      _selImageIds.splice(index, 1);
      _selImageNames.splice(index, 1);
      _images.map((image: Image, index: number) => {
        if (image.ImageId == imageId) {
          image.IsChecked = false;
        }
        if (!image.IsChecked) {
          _allChecked = false;
        }
      });
    }

    setAllChecked(_allChecked);
    setSelImageIds(_selImageIds);
    setSelImageNames(_selImageNames);
    setImages(_images);
  };

  return (
    <Container className="image-page-body">
      <Container className="image-page-content-container">
        <div className="checkbox-container">
          <div className="download">
            <label
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                if (isLoading) return;
                handleDownloadClick(e);
              }}
            >
              {isLoading && <Spinner animation="border" size="sm" />} DOWNLOAD IMAGES
            </label>
            Select All
            <input
              id="chkSelectAll"
              name="chkSelectAll"
              type="checkbox"
              value="true"
              checked={allChecked}
              onChange={(e) => {
                handleSelectAllClick(e);
              }}
            />
          </div>
        </div>
        <div className="image-page-main">
          {images &&
            images.map((image: any, index: number) => {
              return (
                <ImageCard
                  key={image.ImageId}
                  image={image}
                  sku={props.sku}
                  handleSelectImage={handleSelectImage}
                />
              );
            })}
        </div>
      </Container>
    </Container>
  );
};

export default HighResImages;
